// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"6379b899","856":"6444dcb1"}[chunkId] + ".js";
};